export default {
  related: {
    title: 'Related',
    theRelatedListCouldNotBeLoaded: 'The related list could not be loaded'
  }
}
